// extracted by mini-css-extract-plugin
export default {"checkbox":"MGInputCheckbox_checkbox__0Y3oU","input":"MGInputCheckbox_input__6-DtS","visual":"MGInputCheckbox_visual__mKt6R","icon":"MGInputCheckbox_icon__OnYUX"};